import React, { Component } from 'react';
import { 
    withStyles,
    Table,
    TableRow,
    TableBody,
    TableCell,
    TableContainer, 
    TableHead, 
    Typography 
  } from '@material-ui/core';



import Paper from '@material-ui/core/Paper';
import NumericInput from 'react-numeric-input';

import './DashboardSKULimits.scss';

export default class DashboardSKULimits extends Component {

  state = {
    tableColumns: ["ID CLIENTE", "FECHA INICIO", "FECHA FIN", "RENOVACION", "VALOR"],
    rows: this.props.rows
  }

  render() {

    const StyledTableCell = withStyles((theme) => ({
      head: {
        backgroundColor: theme.palette.common.black,
        color: "#FFFF00",
        fontFamily: "Roboto",
        fontstyle: "normal",
        fontWeight: "normal",
        fontSize: 18,
        padding: "8px 30px"
      },
      body: {
        fontSize: 14,
        padding: "9px 30px"
      },
    }))(TableCell);

    const StyledTableRow = withStyles((theme) => ({
      root: {
        '&:nth-of-type(odd)': {
          backgroundColor: theme.palette.action.hover,
        },
      },
    }))(TableRow);
    return(
      <div className="sku-limits">

        <div className="sku-limits__table">
          <TableContainer component={Paper}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {this.state.tableColumns.map((element, key) => (
                    <StyledTableCell align="left" key={key}>
                      {element}{element === "ID CLIENTE" ? <img style={{marginLeft: "2rem"}} src="assets/filter/search.png" alt="" /> : null}
                      </StyledTableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {this.props.rows === undefined ?
                  <TableRow>
                    <TableCell colSpan={5}>
                      <Typography
                        variant='h5'
                        align='center'
                      >
                        - No  hay datos encontrados -
                      </Typography>
                    </TableCell>
                  </TableRow>
                  : this.props.rows.map((row, index) => (
                    <StyledTableRow key={index}>
                      <StyledTableCell align="left">{row.idClient}</StyledTableCell>
                      <StyledTableCell align="left">{row.startDate}</StyledTableCell>
                      <StyledTableCell align="left">{row.endDate}</StyledTableCell>
                      <StyledTableCell align="left">{row.renovation}</StyledTableCell>
                      <StyledTableCell align="left">
                        <NumericInput 
                          min={0}
                          value={row.value}/>
                      </StyledTableCell>
                    </StyledTableRow>
                  ))
                }
              </TableBody>
            </Table>
          </TableContainer>
        </div>

        <div className="sku-limits__actions">
          <button className="sku-limits--button">Guardar registro</button>
        </div>

      </div>
    )
  }

}
